export default "__VITE_ASSET__625ba70b__"